module.exports = __webpack_public_path__ + "img/kemet-fm.7b7a0193.png";